import { proxyApiEndpoint } from '@/environment'
import { createPolkadotChains } from '@pkg/basic'

export const polkadotChains = createPolkadotChains({
  explorerProxyUrl: proxyApiEndpoint,
})
